import React from "react";
import classNames from "classnames";

export function Button({ children, className = "", ...props }) {
  return (
    <button
      className={classNames(
        "inline-flex items-center justify-center px-4 py-2 rounded-full font-semibold transition-colors duration-200",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
